/**
 * 홈 이벤트 배너 카탈로그 — 웹게임 이벤트 보드 문법(Courtyard 홈 캐러셀 +
 * 사이드바 EVENTS 레일 참조). 표시 전용 mock, 수치는 기존 mock 소스에서 파생
 * (§6.6.2 금지 항목 — 환산가·예상 수령량·수익률 — 은 절대 노출하지 않는다).
 * TODO(server): 운영 배너/이벤트 RPC로 교체.
 */
import { BRAND } from "@/lib/brandAssets";
import { cardArtSrc } from "@/lib/cardArt";
import { findOripaPack } from "@/lib/renewal/oripa";
import { MOCK_RANKING } from "@/lib/renewal/seasonHub";
import { SEASON_CONFIG } from "@/lib/season";

export type EventTone = "gold" | "rarity" | "neutral";

export type EventBanner = {
  id: string;
  eyebrow: string;
  title: string;
  /** 1줄 데이터형 캡션 */
  caption: string;
  cta: string;
  to: string;
  /** 지정 시 눈썹 옆 카운트다운 칩 */
  endsAt?: string | null;
  /** 우측 아트 (없으면 타이포만) */
  art?: string | null;
  tone: EventTone;
};

export function eventBanners(): EventBanner[] {
  const banners: EventBanner[] = [
    {
      id: "season-race",
      eyebrow: `${SEASON_CONFIG.label} · Live`,
      title: "Climb the IP ladder",
      caption: `${MOCK_RANKING.participants.toLocaleString("en-US")} collectors racing`,
      cta: "View leaderboard",
      to: "/season",
      endsAt: SEASON_CONFIG.endsAt,
      tone: "gold",
    },
    {
      id: "ultra-chase",
      eyebrow: "Ultra Chase · /1",
      title: "Gold Vinyl /1 is still out there",
      caption: "Season 1 Box exclusive — one copy, one owner",
      cta: "Enter the chase",
      to: "/shop/ultra-chase",
      art: cardArtSrc("grok-x", "gold_vinyl"),
      tone: "rarity",
    },
    {
      // 기획 외 스트릭 보상 프레이밍 제거 — 일일 무료 팩(§5)만 안내
      id: "daily-free",
      eyebrow: "Daily",
      title: "Free pack every day",
      caption: "Claim resets 00:00 UTC",
      cta: "Claim today's pack",
      to: "/profile/packs",
      tone: "neutral",
    },
  ];

  const sovereign = findOripaPack("baller");
  if (sovereign && sovereign.remainingPacks <= sovereign.totalPacks * 0.2) {
    banners.splice(2, 0, {
      id: "sovereign-stock",
      eyebrow: `${sovereign.name} · Low stock`,
      title: `Only ${sovereign.remainingPacks} packs left`,
      caption: `${sovereign.totalPacks} minted · ${sovereign.remainingPacks} remaining`,
      cta: "Open the shop",
      to: "/shop/packs/baller",
      art: BRAND.cardPack,
      tone: "gold",
    });
  }

  return banners;
}
